import styled, { css } from 'styled-components';

import { resetButton } from 'styles/common';

export const Container = styled.div`
  position: fixed;
  top: 66px;
  left: 20px;
  z-index: 10;
  display: flex;
  align-items: stretch;
  gap: 6px;

  @media (max-width: 600px) {
    top: 120px;
    left: 10px;
  }
`;

export const Input = styled.input<{ $error?: boolean }>`
  width: 216px;
  padding: 6px 12px;
  border-radius: 0px;
  background: rgba(10, 10, 20, 0.75);
  border: 1px solid rgba(0, 204, 255, 0.5);
  box-shadow: inset 0 0 10px rgba(0, 204, 255, 0.08);
  color: rgba(200, 230, 255, 0.9);
  font-family: 'Rajdhani', sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  outline: none;
  transition: all 0.3s ease;

  &::placeholder {
    color: rgba(200, 230, 255, 0.35);
    text-transform: uppercase;
  }

  &:focus {
    border-color: rgba(0, 204, 255, 1);
    box-shadow:
      0 0 14px rgba(0, 204, 255, 0.25),
      inset 0 0 10px rgba(0, 204, 255, 0.12);
  }

  ${({ $error }) =>
    $error &&
    css`
      border-color: rgba(255, 80, 80, 0.9);
      box-shadow:
        0 0 14px rgba(255, 80, 80, 0.3),
        inset 0 0 10px rgba(255, 80, 80, 0.12);
    `}

  @media (max-width: 600px) {
    width: 168px;
    font-size: 13px;
  }
`;

export const Button = styled.button`
  ${resetButton}
  padding: 6px 12px;
  border-radius: 0px;
  background: radial-gradient(circle at 35% 30%, rgba(0, 204, 255, 0.2), rgba(0, 17, 34, 0.9));
  border: 1px solid rgba(0, 204, 255, 0.7);
  color: rgba(200, 230, 255, 0.9);
  font-family: 'Rajdhani', sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(0, 204, 255, 1);
    box-shadow: 0 0 18px rgba(0, 204, 255, 0.35);
  }

  &:active {
    transform: scale(0.93);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const Error = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  padding: 3px 10px;
  background: rgba(10, 10, 20, 0.85);
  border: 1px solid rgba(255, 80, 80, 0.7);
  color: rgba(255, 150, 150, 0.95);
  font-family: 'Rajdhani', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  white-space: nowrap;
`;
